module.exports = __webpack_public_path__ + "static/media/02.af8d28d1.png";